module.exports = __webpack_public_path__ + "assets/pm-aktif-logo.17a5bd91.svg";